import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import {
  ArrowBack,
  IconAdd,
  IconDown,
  IconUp,
} from "../components/CustomIcons";
import { Link, useNavigate, useOutletContext, useParams } from "react-router-dom";
import { useCallback, useEffect, useRef, useState } from "react";
import { resizeImage } from "../components/utils/resizeImage";
import { cropImageFile } from "../components/utils/cropImage";
import { validateImageFile } from "../components/utils/imageValidation";
import Cropper from "react-easy-crop";
import { uploadImageWithPath } from "../services/firebase";
import { useAuth } from "../contexts/AuthContext";
import {
  addMerchandiseToLeague,
  getLeagueBySlug,
  getMerchandises,
  updateLeagueBasicInfo,
  updateMerchandiseToLeague,
} from "../components/leagueLocker/firestoreQuery";
import { set } from "lodash";
import { LeagueContext } from "./LeagueLockerPage";
// ...existing code...

const EditMerchPage = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { leagueSlug } = useParams();
  const [league, setLeague] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [existingProductImage, setExistingProductImage] = useState<
    string | null
  >(null);
  const [showAddMerch, setShowAddMerch] = useState(false);
  const [allMerch, setAllMerch] = useState<any[]>([]);
  const [hasOrderChanged, setHasOrderChanged] = useState(false);
  const [isSavingOrder, setIsSavingOrder] = useState(false);

  const [isaddingProduct, setIsAddingProduct] = useState(false);
  const [productImage, setProductImage] = useState<File | null>(null);
  const [imagePreview, setImagePreview] = useState<string | null>(null); // existingImageUrl from leagueData if present
  const [showCropper, setShowCropper] = useState(false);
  const [tempImageUrl, setTempImageUrl] = useState<string | null>(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedArea, setCroppedArea] = useState<any>(null);
  // Loading state for cropper (setter used; omit first element to avoid unused variable)
  const [, setLoadingCropper] = useState(false);
  const productImageRef = useRef<HTMLInputElement | null>(null);
  const [productTitle, setProductTitle] = useState<string>("");
  const [productUrl, setProductUrl] = useState<string>("");
  const [productTitleError, setProductTitleError] = useState<string | null>(
    null
  );
  const [productUrlError, setProductUrlError] = useState<string | null>(null);
  const [productImageError, setProductImageError] = useState<string | null>(
    null
  );

  const [isEditingProduct, setIsEditingProduct] = useState(false);
  const [editingProductId, setEditingProductId] = useState<
    string | null | number | undefined
  >(null);

  const [isProcessing, setIsProcessing] = useState(false);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [removeMerchId, setRemoveMerchId] = useState<
    string | number | undefined | null
  >(null);

  useEffect(() => {
    const fetchLeagueDetails = async () => {
      if (leagueSlug) {
        try {
          const res = await getLeagueBySlug(leagueSlug);
          console.log("Fetched league data:", res);
          if (res) {
            if (res.createdBy !== user?.uid) {
              navigate("/dashboard");
              return;
            } else {
              setLeague(res);
            }
          } else {
            navigate("/dashboard");
          }
        } catch (error) {
          console.error("Error fetching league:", error);
          //setErrorText(error as string);
        }
      }
      //setIsLoading(false);
    };
    fetchLeagueDetails();
  }, [leagueSlug, navigate, user?.uid]);

  useEffect(() => {
    const fetchMerchDetails = async () => {
      if (league === null) return;
      try {
        const res = await getMerchandises(league.id);
        setAllMerch(res);
      } catch (error) {
        console.error("Error fetching merchandises:", error);
      }
    };
    fetchMerchDetails();
  }, [league]);

  // Move merch locally by swapping positions and updating displayOrder
  const moveMerch = (index: number, delta: number) => {
    if (!allMerch || allMerch.length === 0) return;
    const newIndex = index + delta;
    if (newIndex < 0 || newIndex >= allMerch.length) return;

    const newMerch = [...allMerch];
    // swap
    const tmp = newMerch[newIndex];
    newMerch[newIndex] = newMerch[index];
    newMerch[index] = tmp;

    // reassign displayOrder sequentially (1-based)
    const reordered = newMerch.map((m, i) => ({ ...m, displayOrder: i + 1 }));
    setAllMerch(reordered);
    setHasOrderChanged(true);
  };

  // Persist the reordered merchandise array to the league document
  const saveOrder = async () => {
    if (!league?.id) return;
    if (!hasOrderChanged) return;
    setIsSavingOrder(true);
    try {
      // Prepare merchandise payload - keep existing fields but ensure displayOrder is set
      const payload = allMerch.map((m, i) => {
        // include only expected fields for firestore merchandise array
        return {
          productId: m.productId,
          productTitle: m.productTitle,
          productImage: m.productImage,
          productUrl: m.productUrl,
          displayOrder:
            typeof m.displayOrder === "number" ? m.displayOrder : i + 1,
        };
      });

      await updateLeagueBasicInfo(league.id, { merchandise: payload });

      // Refresh local merch from server to ensure consistency
      const res = await getMerchandises(league.id);
      setAllMerch(res);
      setHasOrderChanged(false);
    } catch (error) {
      console.error("Error saving merch order:", error);
    } finally {
      setIsSavingOrder(false);
    }
  };

  //remove merch by id
  //reorder the remaining merch
  //save the updated merch array to firestore
  //refresh local merch state from server
  const removeMerch = async (productId: string | number | undefined) => {
    if (!league?.id) return;
    if (!productId) return;
    setIsProcessing(true);
    try {
      const updatedMerch = allMerch.filter((m) => m.productId !== productId);
      // reassign displayOrder sequentially (1-based)
      const reordered = updatedMerch.map((m, i) => ({
        ...m,
        displayOrder: i + 1,
      }));
      await updateLeagueBasicInfo(league.id, { merchandise: reordered });
      const res = await getMerchandises(league.id);
      setAllMerch(res);
    } catch (error) {
      console.error("Error removing merchandise:", error);
    } finally {
      setIsProcessing(false);
    }
  };

  const handleImageChange = useCallback(
    async (e: React.ChangeEvent<HTMLInputElement>) => {
      // clear image error when user selects a new file
      setProductImageError(null);
      const file = e.target.files?.[0];
      if (!file) return;
      const validationError = validateImageFile(file);
      if (validationError) {
        alert(`${validationError}`);
        return;
      }
      setLoadingCropper(true);
      try {
        const { resizedUrl } = await resizeImage(file);
        setTempImageUrl(resizedUrl);
        setShowCropper(true);
      } finally {
        setLoadingCropper(false);
      }
    },
    []
  );

  const onCropComplete = useCallback((_: any, croppedPixels: any) => {
    setCroppedArea(croppedPixels);
  }, []);

  const handleCropConfirm = useCallback(async () => {
    if (!tempImageUrl || !croppedArea) return;
    const cropped = await cropImageFile(tempImageUrl, croppedArea);
    if (cropped) {
      setProductImage(cropped);
      // clear any previous image error after successful crop/upload
      setProductImageError(null);
      setImagePreview(URL.createObjectURL(cropped));
    }
    setShowCropper(false);
  }, [tempImageUrl, croppedArea]);

  const handleRemoveImage = () => {
    setProductImage(null);
    setImagePreview(null);
    setProductImageError(null);
    if (productImageRef.current) productImageRef.current.value = "";
  };

  const handleOnAddProduct = async () => {
    // Reset errors
    setProductTitleError(null);
    setProductUrlError(null);
    setProductImageError(null);

    let hasError = false;

    // Validate title
    if (!productTitle || productTitle.trim() === "") {
      setProductTitleError("Product title is required");
      hasError = true;
    }

    // Validate URL
    if (!productUrl || productUrl.trim() === "") {
      setProductUrlError("Product URL is required");
      hasError = true;
    } else {
      try {
        const parsed = new URL(productUrl);
        if (parsed.protocol !== "http:" && parsed.protocol !== "https:") {
          setProductUrlError("Enter a valid URL (http or https)");
          hasError = true;
        }
      } catch (err) {
        setProductUrlError("Enter a valid URL (e.g. https://example.com)");
        hasError = true;
      }
    }

    // Validate image
    if (!productImage && isaddingProduct) {
      setProductImageError("Product image is required");
      hasError = true;
    }
    if (hasError) {
      return;
    }

    if (isaddingProduct && !isEditingProduct) {
      setIsProcessing(true);
      let productImageUrl =
        existingProductImage && imagePreview ? existingProductImage : "";
      if (productImage) {
        const imagePath = `leagueLocker/${league?.id}/merchant/${Date.now()}_${
          productImage.name
        }`;
        productImageUrl =
          existingProductImage && imagePreview ? existingProductImage : "";
        try {
          productImageUrl = await uploadImageWithPath(productImage, imagePath);
        } catch (error) {
          console.error("Error uploading image:", error);
        }

        const payload = {
          productTitle: productTitle,
          productUrl: productUrl,
          productImage: productImageUrl,
          productId: `${league?.id}_${Date.now()}`,
        };

        try {
          
          await addMerchandiseToLeague(league.id, payload);
          const res = await getMerchandises(league.id);
          setAllMerch(res);
          // Close the add product panel
          setShowAddMerch(false);

          // Clear all product related states so the form is reset next time
          setProductTitle("");
          setProductUrl("");
          setProductImage(null);
          setImagePreview(null);
          setTempImageUrl(null);
          setCrop({ x: 0, y: 0 });
          setZoom(1);
          setCroppedArea(null);
          setProductTitleError(null);
          setProductUrlError(null);
          setProductImageError(null);
          setIsProcessing(false);
        } catch (error) {
          console.error("Error adding merchandise:", error);
          setIsProcessing(false);
        }
      }
      setIsAddingProduct(false);
    }

    if (isEditingProduct && !isaddingProduct && editingProductId) {
      setIsProcessing(true);
      let productImageUrl =
        existingProductImage && imagePreview ? existingProductImage : "";
      if (productImage) {
        const imagePath = `leagueLocker/${league?.id}/merchant/${Date.now()}_${
          productImage.name
        }`;
        productImageUrl =
          existingProductImage && imagePreview ? existingProductImage : "";
        try {
          productImageUrl = await uploadImageWithPath(productImage, imagePath);
        } catch (error) {
          console.error("Error uploading image:", error);
        }
      }

      if (!productImage && !productImageUrl) {
        setProductImageError("Product image is required");
        hasError = true;
        return;
      }
      // Update the specific merchandise item
      
      const update = await updateMerchandiseToLeague(
        league.id,
        editingProductId,
        {
          productTitle: productTitle,
          productUrl: productUrl,
          productImage: productImageUrl,
        }
      );
      if (update) {
        console.log("Merchandise updated successfully");
        const res = await getMerchandises(league.id);
        setAllMerch(res);
        setIsEditingProduct(false);
        setEditingProductId(null);
        setShowAddMerch(false);

        // Clear all product related states so the form is reset next time
        setProductTitle("");
        setProductUrl("");
        setProductImage(null);
        setImagePreview(null);
        setExistingProductImage(null);
        setTempImageUrl(null);
        setCrop({ x: 0, y: 0 });
        setZoom(1);
        setCroppedArea(null);
        setProductTitleError(null);
        setProductUrlError(null);
        setProductImageError(null);
      }
      setIsProcessing(false);
    }
  };

  const loaderInline = () => {
    return (
      <div className="w-4 h-4 border-2 border-[#18f7b1] border-t-transparent rounded-full animate-spin" />
    );
  };

  return (
    <div className="pageOuterWrapper">
      <Navbar />
      <div className="contentArea otherContentArea">
        <div className="wrapper">
          <div className="backWrap">
            <Link to={`/manage-league/${leagueSlug}`}>
              <ArrowBack /> Back
            </Link>
          </div>
          <div className="yourLeagueHeader">
            <div className="headingItem">Manage Merch</div>
            <div className="actionItems">
              <button
                className="btnStyle btnFilled"
                onClick={saveOrder}
                disabled={!hasOrderChanged || isSavingOrder}
              >
                {isSavingOrder ? "SAVING..." : "SAVE"}
              </button>
            </div>
          </div>
          {!showAddMerch ? (
            <div className="shadowBlk">
              <div
                className="addBlk"
                onClick={() => {
                  setShowAddMerch(true);
                  setIsAddingProduct(true);
                  setIsEditingProduct(false);
                  setEditingProductId(null);
                }}
              >
                <IconAdd />
                <span>ADD MERCH</span>
              </div>
            </div>
          ) : (
            <div className="shadowBlk">
              <div className="blkHeading">
                <span>
                  {isaddingProduct ? "Add New Product" : "Edit Product"}
                </span>
              </div>

              {showCropper && tempImageUrl && (
                <div className="popupWrapper fixed inset-0 bg-black bg-opacity-80 z-50 flex items-center justify-center">
                  <div className="relative w-[90vw] max-w-2xl h-[90vh] bg-white rounded-lg overflow-hidden shadow-lg">
                    <Cropper
                      image={tempImageUrl}
                      crop={crop}
                      zoom={zoom}
                      aspect={4 / 4}
                      onCropChange={setCrop}
                      onZoomChange={setZoom}
                      onCropComplete={onCropComplete}
                    />
                    <div className="absolute bottom-0 left-0 w-full flex justify-between p-4 bg-white border-t">
                      <button
                        type="button"
                        onClick={() => setShowCropper(false)}
                        className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600"
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        onClick={handleCropConfirm}
                        className="px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600"
                      >
                        Crop & Save
                      </button>
                    </div>
                  </div>
                </div>
              )}

              <div className="uploadArea bottomGap1">
                {!imagePreview && (
                  <>
                    <input
                      type="file"
                      accept="image/*"
                      style={{ display: "none" }}
                      ref={productImageRef}
                      onChange={handleImageChange}
                    />
                    <button
                      className="btnStyle btnHighlighted"
                      type="button"
                      onClick={() => productImageRef.current?.click()}
                    >
                      UPLOAD PRODUCT IMAGE
                    </button>
                  </>
                )}

                {imagePreview && (
                  <div className="mt-2 relative inline-block">
                    <img
                      src={imagePreview}
                      alt="Punishment Preview"
                      style={{ maxWidth: 170, borderRadius: 8 }}
                    />
                    <button
                      type="button"
                      onClick={() => {
                        handleRemoveImage();
                      }}
                      className="absolute top-1 right-1 bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center hover:bg-red-600"
                      style={{ lineHeight: 1, fontSize: 16 }}
                      aria-label="Remove image"
                    >
                      ×
                    </button>
                  </div>
                )}
              </div>
              {productImageError && (
                <div className="errorText mb-2">{productImageError}</div>
              )}
              <div className="formGroup">
                <label htmlFor="leagueName">
                  Product Title <span className="reqTxt">Required</span>
                </label>
                <input
                  type="text"
                  id="leagueName"
                  className={productTitleError ? "fldError" : undefined}
                  placeholder="Enter your product title"
                  value={productTitle}
                  onChange={(e) => {
                    setProductTitle(e.target.value);
                    if (productTitleError) setProductTitleError(null);
                  }}
                />
                {productTitleError && (
                  <div className="errorText">{productTitleError}</div>
                )}
              </div>
              <div className="formGroup">
                <label htmlFor="leagueBio">
                  Product URL <span className="reqTxt">Required</span>
                </label>
                <input
                  type="text"
                  id="leagueBio"
                  className={productUrlError ? "fldError" : undefined}
                  placeholder="https://example.com/product"
                  value={productUrl}
                  onChange={(e) => {
                    setProductUrl(e.target.value);
                    if (productUrlError) setProductUrlError(null);
                  }}
                />
                {productUrlError && (
                  <div className="errorText">{productUrlError}</div>
                )}
              </div>
              <div className="btnWrap">
                {/* Cancel button to close the add/edit panel */}
                <button
                  className="btnStyle"
                  onClick={() => {
                    setIsAddingProduct(false);
                    setIsEditingProduct(false);
                    setEditingProductId(null);
                    setProductTitle("");
                    setProductUrl("");
                    setProductImage(null);
                    setExistingProductImage(null);
                    setImagePreview(null);
                    setTempImageUrl(null);
                    setCrop({ x: 0, y: 0 });
                    setZoom(1);
                    setCroppedArea(null);
                    setProductTitleError(null);
                    setProductUrlError(null);
                    setProductImageError(null);
                    setShowAddMerch(false);
                  }}
                >
                  CANCEL
                </button>
                <button
                  className="btnStyle btnFilled"
                  onClick={() => {
                    handleOnAddProduct();
                  }}
                  disabled={isProcessing}
                >
                  {isaddingProduct && !isEditingProduct
                    ? "ADD PRODUCT"
                    : isEditingProduct && !isaddingProduct
                    ? "UPDATE PRODUCT"
                    : ""}

                  {isProcessing && (
                    <span className="inline-block ml-2">{loaderInline()}</span>
                  )}
                </button>
              </div>
            </div>
          )}
          <ul className="marchItemList">
            {allMerch && allMerch.length > 0 ? (
              [...allMerch]
                .sort((a, b) => (a.displayOrder ?? 0) - (b.displayOrder ?? 0))
                .map((merch: any, idx: number, arr: any[]) => {
                  const id = merch.id ?? idx;
                  const isFirst = idx === 0;
                  const isLast = idx === arr.length - 1;
                  return (
                    <li key={id}>
                      <div className="itemHeading">{merch.productTitle}</div>
                      <div className="itemPic">
                        <img
                          src={merch.productImage ?? ""}
                          alt={merch.productTitle ?? `product-${id}`}
                        />
                      </div>
                      <div className="itemActions">
                        <button
                          className="btnStyle btnDanger"
                          type="button"
                          onClick={() => {
                            console.log("Delete merch", id);
                            setShowConfirmDialog(true);
                            setRemoveMerchId(merch.productId);
                          }}
                        >
                          REMOVE
                        </button>
                        <button
                          className="btnStyle btnFilled"
                          type="button"
                          onClick={() => {
                            console.log("Edit merch", id);
                            //scroll to top
                            window.scrollTo({ top: 0, behavior: "smooth" });
                            // implement edit logic here
                            setIsAddingProduct(false);
                            setShowAddMerch(true);
                            setProductImage(null);
                            setIsEditingProduct(true);
                            setProductTitle(merch.productTitle ?? "");
                            setProductUrl(merch.productUrl ?? "");
                            setExistingProductImage(merch.productImage ?? "");
                            setImagePreview(merch.productImage ?? null);
                            setEditingProductId(merch.productId);
                            // Note: For editing, we are not changing the existing productImage file
                            // unless user uploads a new one. So productImage remains null.
                          }}
                        >
                          EDIT
                        </button>
                      </div>
                      <div className="orderAction">
                        <button
                          className="iconOnly"
                          type="button"
                          disabled={isFirst}
                          onClick={() => moveMerch(idx, -1)}
                          aria-label={`Move ${merch.productTitle} up`}
                        >
                          <IconUp />
                        </button>
                        <button
                          className="iconOnly"
                          type="button"
                          disabled={isLast}
                          onClick={() => moveMerch(idx, 1)}
                          aria-label={`Move ${merch.productTitle} down`}
                        >
                          <IconDown />
                        </button>
                      </div>
                    </li>
                  );
                })
            ) : (
              <li>
                <div className="itemHeading">No products added yet</div>
              </li>
            )}
          </ul>
          <button
            className="btnStyle btnFilled btnFull"
            onClick={saveOrder}
            disabled={!hasOrderChanged || isSavingOrder}
          >
            {isSavingOrder ? "SAVING..." : "SAVE"}
          </button>
        </div>
      </div>
      {showConfirmDialog && removeMerchId && (
        <div className="popupWrap">
          <div className="popupContBlk">
            <div className="headingTxt">Remove Merch?</div>
            <p>Are you sure you want to remove this merch item?</p>
            <div className="adminActionWrap">
              <button
                className="btnStyle"
                onClick={() => {
                  setShowConfirmDialog(false);
                  setRemoveMerchId(null);
                }}
              >
                Cancel
              </button>
              <button
                onClick={async () => {
                  await removeMerch(removeMerchId);
                  setShowConfirmDialog(false);
                  setRemoveMerchId(null);
                }}
                className="btnStyle btnFilled"
                disabled={isProcessing}
              >
                Remove
                {isProcessing && (
                  <span className="inline-block ml-2">{loaderInline()}</span>
                )}
              </button>
            </div>
          </div>
        </div>
      )}
      <Footer />
    </div>
  );
};

export default EditMerchPage;
